<template>
  <div class="card green">
    <div class="content">
      <div class="header">
        {{ $t('WINDOW') }}
        <i class="right floated desktop icon"></i>
      </div>
      <div
        class="meta"
        v-html="
          $t('WINDOW_META', {
            type: trigger.externalType,
            title: trigger.configuration.title,
            class: trigger.configuration.class
          })
        "
      ></div>
    </div>
    <div class="primary content">
      <!-- Type of event -->
      <div class="inline fields">
        <label :for="'windowEvent' + rand">{{ $tc('WINDOW_EVENT', 1) }}</label>
        <div class="field" v-for="(item, index) of windowEvents" :key="index">
          <div class="ui radio checkbox" :for="'windowEvent' + index">
            <input
              type="radio"
              :name="'windowEvent' + rand"
              :id="'windowEvent' + index"
              v-model="trigger.externalType"
              :value="item.id"
            />
            <label>{{ $t(item.name) }}</label>
          </div>
        </div>
      </div>

      <!-- Title and class -->
      <regex-field
        v-model="trigger.configuration.title"
        :labelText="$t('WINDOW_TITLE')"
        :placeholder="$t('WINDOW_TITLE')"
      />
      <regex-field
        v-model="trigger.configuration.class"
        :labelText="$t('WINDOW_CLASS')"
        :placeholder="$t('WINDOW_CLASS')"
      />

      <!-- Close window? -->
      <div class="field" v-if="trigger.externalType === 'WINDOW_SHOWN'">
        <div class="ui toggle checkbox">
          <input
            id="closeWindow"
            type="checkbox"
            name="closeWindow"
            v-model="trigger.configuration.closeWindow"
          />
          <label for="closeWindow">{{ $t('CLOSE_WINDOW') }}</label>
        </div>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import _ from 'lodash'
import { RegexField } from 'ui'

export default {
  name: 'windowtrigger',
  components: { RegexField },
  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          externalType: '',
          configuration: {
            title: '',
            class: '',
            closeWindow: false
          }
        }
      }
    }
  },

  data() {
    return {
      rand: Math.random(),
      windowEvents: [
        {
          id: 'WINDOW_SHOWN',
          name: 'WINDOW_SHOWN'
        },
        {
          id: 'WINDOW_HIDDEN',
          name: 'WINDOW_HIDDEN'
        }
      ]
    }
  }
}
</script>
